"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECanalPagamentoTypesBBrasil = exports.EFormaPagamentoBBrasil = exports.ETipoPessoaPortadorBBrasil = exports.EPaymentStateBBrasil = exports.EPaymentTypeBaixaBBrasil = exports.EPaymentAttTypesBBrasil = exports.EStatusPayment = exports.EPaymentAttTypesIugu = exports.EPaymentTypesIugu = exports.EPaymentAttTypes = exports.EPaymentTypes = exports.ETypeWh = exports.EStatusWh = exports.EFintechNamed = exports.EFintech = exports.EIntegrationLogType = exports.EIntegrationLogAction = void 0;
var EIntegrationLogAction;
(function (EIntegrationLogAction) {
    EIntegrationLogAction["CRONJOB"] = "CRON_JOB";
    EIntegrationLogAction["WEBHOOK"] = "WEBHOOK";
})(EIntegrationLogAction = exports.EIntegrationLogAction || (exports.EIntegrationLogAction = {}));
var EIntegrationLogType;
(function (EIntegrationLogType) {
    EIntegrationLogType["CONSULTA_MOVTO_BBRASIL"] = "CONSULTA_MOVTO_BBRASIL";
    EIntegrationLogType["WEBHOOK_IUGU"] = "WEBHOOK_IUGU";
    EIntegrationLogType["WEBHOOK_PJBANK"] = "WEBHOOK_PJBANK";
    EIntegrationLogType["WEBHOOK_BBRASIL"] = "WEBHOOK_BBRASIL";
})(EIntegrationLogType = exports.EIntegrationLogType || (exports.EIntegrationLogType = {}));
var EFintech;
(function (EFintech) {
    EFintech["Juno"] = "J";
    EFintech["PJBank"] = "P";
    EFintech["Iugu"] = "I";
    EFintech["BBrasil"] = "B";
})(EFintech = exports.EFintech || (exports.EFintech = {}));
var EFintechNamed;
(function (EFintechNamed) {
    EFintechNamed["JUNO"] = "JUNO";
    EFintechNamed["PJBANK"] = "PJBANK";
    EFintechNamed["IUGU"] = "IUGU";
    EFintechNamed["BBRASIL"] = "BBRASIL";
})(EFintechNamed = exports.EFintechNamed || (exports.EFintechNamed = {}));
var EStatusWh;
(function (EStatusWh) {
    EStatusWh["ACTIVE"] = "ACTIVE";
    EStatusWh["DISABLED"] = "DISABLED";
    EStatusWh["ENABLED"] = "ENABLED";
})(EStatusWh = exports.EStatusWh || (exports.EStatusWh = {}));
var ETypeWh;
(function (ETypeWh) {
    ETypeWh["DIGITAL_ACCOUNT_STATUS_CHANGED"] = "DIGITAL_ACCOUNT_STATUS_CHANGED";
    ETypeWh["DIGITAL_ACCOUNT_CREATED"] = "DIGITAL_ACCOUNT_CREATED";
    ETypeWh["DOCUMENT_STATUS_CHANGED"] = "DOCUMENT_STATUS_CHANGED";
    ETypeWh["TRANSFER_STATUS_CHANGED"] = "TRANSFER_STATUS_CHANGED";
    ETypeWh["P2P_TRANSFER_STATUS_CHANGED"] = "P2P_TRANSFER_STATUS_CHANGED";
    ETypeWh["CHARGE_STATUS_CHANGED"] = "CHARGE_STATUS_CHANGED";
    ETypeWh["CHARGE_READ_CONFIRMATION"] = "CHARGE_READ_CONFIRMATION";
    ETypeWh["PAYMENT_NOTIFICATION"] = "PAYMENT_NOTIFICATION";
    ETypeWh["BILL_PAYMENT_STATUS_CHANGED"] = "BILL_PAYMENT_STATUS_CHANGED";
    ETypeWh["INVOICE_STATUS_CHANGED"] = "invoice.status_changed";
})(ETypeWh = exports.ETypeWh || (exports.ETypeWh = {}));
var EPaymentTypes;
(function (EPaymentTypes) {
    EPaymentTypes["BOLETO"] = "BOLETO";
    EPaymentTypes["BOLETO_PIX"] = "BOLETO_PIX";
    EPaymentTypes["CREDIT_CARD"] = "CREDIT_CARD";
})(EPaymentTypes = exports.EPaymentTypes || (exports.EPaymentTypes = {}));
var EPaymentAttTypes;
(function (EPaymentAttTypes) {
    EPaymentAttTypes["INSTALLMENT_CREDIT_CARD"] = "CREDIT_CARD";
    EPaymentAttTypes["PIX_DYNAMIC_QRCODE"] = "PIX_DYNAMIC";
    EPaymentAttTypes["BOLETO"] = "BOLETO";
})(EPaymentAttTypes = exports.EPaymentAttTypes || (exports.EPaymentAttTypes = {}));
var EPaymentTypesIugu;
(function (EPaymentTypesIugu) {
    EPaymentTypesIugu["ALL"] = "all";
    EPaymentTypesIugu["CREDIT_CARD"] = "credit_card";
    EPaymentTypesIugu["BANK_SLIP"] = "bank_slip";
    EPaymentTypesIugu["PIX"] = "pix";
})(EPaymentTypesIugu = exports.EPaymentTypesIugu || (exports.EPaymentTypesIugu = {}));
var EPaymentAttTypesIugu;
(function (EPaymentAttTypesIugu) {
    EPaymentAttTypesIugu["IUGU_BANK_SLIP"] = "iugu_bank_slip";
    EPaymentAttTypesIugu["IUGU_BANK_SLIP_TEST"] = "iugu_bank_slip_test";
    EPaymentAttTypesIugu["IUGU_PIX"] = "iugu_pix";
    EPaymentAttTypesIugu["IUGU_PIX_TEST"] = "iugu_pix_test";
    EPaymentAttTypesIugu["IUGU_CREDIT_CARD"] = "iugu_credit_card";
    EPaymentAttTypesIugu["IUGU_CREDIT_CARD_TEST"] = "iugu_credit_card_test";
})(EPaymentAttTypesIugu = exports.EPaymentAttTypesIugu || (exports.EPaymentAttTypesIugu = {}));
var EStatusPayment;
(function (EStatusPayment) {
    EStatusPayment["NONE"] = "";
    EStatusPayment["CONFIRMED"] = "CONFIRMED";
    EStatusPayment["REFRESHED"] = "REFRESHED";
    EStatusPayment["SCHEDULED"] = "SCHEDULED";
})(EStatusPayment = exports.EStatusPayment || (exports.EStatusPayment = {}));
// canalAgendamento
var EPaymentAttTypesBBrasil;
(function (EPaymentAttTypesBBrasil) {
    EPaymentAttTypesBBrasil[EPaymentAttTypesBBrasil["AGENCIAS_POSTOS_TRADICIONAIS"] = 1] = "AGENCIAS_POSTOS_TRADICIONAIS";
    EPaymentAttTypesBBrasil[EPaymentAttTypesBBrasil["TERMINAL_DE_AUTO_ATENDIMENTO"] = 2] = "TERMINAL_DE_AUTO_ATENDIMENTO";
    EPaymentAttTypesBBrasil[EPaymentAttTypesBBrasil["INTERNET_HOME_OFFICE_BANKING"] = 3] = "INTERNET_HOME_OFFICE_BANKING";
    EPaymentAttTypesBBrasil[EPaymentAttTypesBBrasil["PIX"] = 4] = "PIX";
    EPaymentAttTypesBBrasil[EPaymentAttTypesBBrasil["CORRESPONDENTE_BANCARIO"] = 5] = "CORRESPONDENTE_BANCARIO";
    EPaymentAttTypesBBrasil[EPaymentAttTypesBBrasil["CENTRAL_DE_ATENDIMENTO_CALL_CENTER"] = 6] = "CENTRAL_DE_ATENDIMENTO_CALL_CENTER";
    EPaymentAttTypesBBrasil[EPaymentAttTypesBBrasil["ARQUIVO_ELETRONICO"] = 7] = "ARQUIVO_ELETRONICO";
    EPaymentAttTypesBBrasil[EPaymentAttTypesBBrasil["DDA"] = 8] = "DDA";
    EPaymentAttTypesBBrasil[EPaymentAttTypesBBrasil["CORRESPONDENTE_BANCARIO_DIGITAL"] = 9] = "CORRESPONDENTE_BANCARIO_DIGITAL";
})(EPaymentAttTypesBBrasil = exports.EPaymentAttTypesBBrasil || (exports.EPaymentAttTypesBBrasil = {}));
var EPaymentTypeBaixaBBrasil;
(function (EPaymentTypeBaixaBBrasil) {
    EPaymentTypeBaixaBBrasil[EPaymentTypeBaixaBBrasil["BAIXA_OPERACIONAL_EMITIDA_PELO_BB"] = 1] = "BAIXA_OPERACIONAL_EMITIDA_PELO_BB";
    EPaymentTypeBaixaBBrasil[EPaymentTypeBaixaBBrasil["BAIXA_OPERACIONAL_EMITIDA_POR_OUTRO_BANCO"] = 2] = "BAIXA_OPERACIONAL_EMITIDA_POR_OUTRO_BANCO";
    EPaymentTypeBaixaBBrasil[EPaymentTypeBaixaBBrasil["CANCELAMENTO_DE_BAIXA_OPERACIONAL"] = 10] = "CANCELAMENTO_DE_BAIXA_OPERACIONAL";
})(EPaymentTypeBaixaBBrasil = exports.EPaymentTypeBaixaBBrasil || (exports.EPaymentTypeBaixaBBrasil = {}));
var EPaymentStateBBrasil;
(function (EPaymentStateBBrasil) {
    EPaymentStateBBrasil[EPaymentStateBBrasil["NORMAL"] = 1] = "NORMAL";
    EPaymentStateBBrasil[EPaymentStateBBrasil["MOVIMENTO_CARTORIO"] = 2] = "MOVIMENTO_CARTORIO";
    EPaymentStateBBrasil[EPaymentStateBBrasil["EM_CARTORIO"] = 3] = "EM_CARTORIO";
    EPaymentStateBBrasil[EPaymentStateBBrasil["TITULO_COM_OCORRENCIA_DE_CARTORIO"] = 4] = "TITULO_COM_OCORRENCIA_DE_CARTORIO";
    EPaymentStateBBrasil[EPaymentStateBBrasil["PROTESTADO_ELETRONICO"] = 5] = "PROTESTADO_ELETRONICO";
    EPaymentStateBBrasil[EPaymentStateBBrasil["LIQUIDADO"] = 6] = "LIQUIDADO";
    EPaymentStateBBrasil[EPaymentStateBBrasil["BAIXADO"] = 7] = "BAIXADO";
    EPaymentStateBBrasil[EPaymentStateBBrasil["TITULO_COM_PENDENCIA_DE_CARTORIO"] = 8] = "TITULO_COM_PENDENCIA_DE_CARTORIO";
    EPaymentStateBBrasil[EPaymentStateBBrasil["TITULO_PROTESTADO_MANUAL"] = 9] = "TITULO_PROTESTADO_MANUAL";
})(EPaymentStateBBrasil = exports.EPaymentStateBBrasil || (exports.EPaymentStateBBrasil = {}));
// #region BBrasil A partir 03/10/2024
var ETipoPessoaPortadorBBrasil;
(function (ETipoPessoaPortadorBBrasil) {
    ETipoPessoaPortadorBBrasil[ETipoPessoaPortadorBBrasil["FISICA"] = 1] = "FISICA";
    ETipoPessoaPortadorBBrasil[ETipoPessoaPortadorBBrasil["JURIDICA"] = 2] = "JURIDICA";
})(ETipoPessoaPortadorBBrasil = exports.ETipoPessoaPortadorBBrasil || (exports.ETipoPessoaPortadorBBrasil = {}));
var EFormaPagamentoBBrasil;
(function (EFormaPagamentoBBrasil) {
    EFormaPagamentoBBrasil[EFormaPagamentoBBrasil["ESPECIE"] = 1] = "ESPECIE";
    EFormaPagamentoBBrasil[EFormaPagamentoBBrasil["DEBITO_CONTA"] = 2] = "DEBITO_CONTA";
    EFormaPagamentoBBrasil[EFormaPagamentoBBrasil["CARTAO_CREDITO"] = 3] = "CARTAO_CREDITO";
    EFormaPagamentoBBrasil[EFormaPagamentoBBrasil["CHEQUE"] = 4] = "CHEQUE";
})(EFormaPagamentoBBrasil = exports.EFormaPagamentoBBrasil || (exports.EFormaPagamentoBBrasil = {}));
var ECanalPagamentoTypesBBrasil;
(function (ECanalPagamentoTypesBBrasil) {
    ECanalPagamentoTypesBBrasil[ECanalPagamentoTypesBBrasil["AGENCIAS_POSTOS_TRADICIONAIS"] = 1] = "AGENCIAS_POSTOS_TRADICIONAIS";
    ECanalPagamentoTypesBBrasil[ECanalPagamentoTypesBBrasil["TERMINAL_DE_AUTO_ATENDIMENTO"] = 2] = "TERMINAL_DE_AUTO_ATENDIMENTO";
    ECanalPagamentoTypesBBrasil[ECanalPagamentoTypesBBrasil["INTERNET_HOME_OFFICE_BANKING"] = 3] = "INTERNET_HOME_OFFICE_BANKING";
    ECanalPagamentoTypesBBrasil[ECanalPagamentoTypesBBrasil["PIX"] = 4] = "PIX";
    ECanalPagamentoTypesBBrasil[ECanalPagamentoTypesBBrasil["CORRESPONDENTE_BANCARIO"] = 5] = "CORRESPONDENTE_BANCARIO";
    ECanalPagamentoTypesBBrasil[ECanalPagamentoTypesBBrasil["CENTRAL_DE_ATENDIMENTO_CALL_CENTER"] = 6] = "CENTRAL_DE_ATENDIMENTO_CALL_CENTER";
    ECanalPagamentoTypesBBrasil[ECanalPagamentoTypesBBrasil["ARQUIVO_ELETRONICO"] = 7] = "ARQUIVO_ELETRONICO";
    ECanalPagamentoTypesBBrasil[ECanalPagamentoTypesBBrasil["DDA"] = 8] = "DDA";
    ECanalPagamentoTypesBBrasil[ECanalPagamentoTypesBBrasil["CORRESPONDENTE_BANCARIO_DIGITAL"] = 9] = "CORRESPONDENTE_BANCARIO_DIGITAL";
    ECanalPagamentoTypesBBrasil[ECanalPagamentoTypesBBrasil["OUTROS"] = 99] = "OUTROS";
})(ECanalPagamentoTypesBBrasil = exports.ECanalPagamentoTypesBBrasil || (exports.ECanalPagamentoTypesBBrasil = {}));
// #endregion BBrasil A partir 03/10/2024
